var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page d-flex flex-row w-100 position-relative"},[_c(_setup.ResponsiveLayout,{scopedSlots:_vm._u([{key:"default",fn:function({ isMobile }){return [_c('Nuxt'),_vm._v(" "),_c('ComposedButtonSupport',{staticClass:"support-button position-fixed z-index-9",attrs:{"mobile":isMobile}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }